export default class CompaniesMain {
    constructor(main) {
        this._main = main;
        this._companies = this._main
            .querySelector('.js-roi-search-engine-companies');
        this._companyDropdown = this._main
            .querySelector('.js-roi-search-engine__field--companies');
        this._companyInput = this._main
            .querySelector('[name="company_id"]');
        this._init();
    }

    _init() {
        if (this._companyDropdown) {
            this._checkSelectedCompany();
            this._updateInputCompaniesValue();
        }
    }

    _updateInputCompaniesValue() {
        this._companyDropdown.addEventListener('change', ({ target }) => {
            this._companyInput.value = target.value;
        });
    }

    _checkSelectedCompany() {
        document.querySelector('body').addEventListener('RoiEngineReady', () => {
            const companyValue = this._companyInput.value,
                options = this._companyDropdown.querySelectorAll('option');

            if (options >= 1) {
                this._companyDropdown.selectedIndex = 0;
            }

            options.forEach(({ value }, index) => {
                if (value === companyValue) {
                    this._companyDropdown.selectedIndex = index;
                }
            });
        });
    }
}
